import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './MenuButton.scss'

type MenuButtonProps = {
    readonly title: string,
    readonly items: string[],
    readonly loading: boolean,
    readonly onSelect: (selectedItem: string) => void
}

export default function MenuButton({ items, title, onSelect, loading }: MenuButtonProps) {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className='menu-button-content'>
            <button disabled={loading} type='button' id="demo-positioned-button" className='menu-button'
                aria-controls={open ? 'demo-positioned-menu' : undefined} aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                {title}
            </button>
            <Menu id="demo-positioned-menu" aria-labelledby="demo-positioned-button" anchorEl={anchorEl} open={open} onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center', }} transformOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                style={{ borderRadius: '10px' }}>
                {items.map((item) =>
                    <MenuItem style={{ width: '100px', fontSize: '14px', fontWeight: '600' }} onClick={() => { onSelect(item); handleClose(); }}>
                        {item}
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
}